// extracted by mini-css-extract-plugin
export var navigation = "navigation-module--navigation--kqix2 accordion-module--accordion-content--0lJF0";